module.exports = __webpack_public_path__ + "24e004ab/img/pwrd-by-sourcery-black.bba9ba41.svg";